<template>
  <div class="main-body">   <!--审批查询页面-->
    <div class="main-body-search">
      <el-form :model="filters" @submit.native.prevent  label-width="auto">
          <el-row :gutter="20">
            <el-col :span="5">
              <el-form-item  required>
                <el-date-picker type="date" placeholder="提交时间起" style="width: 100%;" value-format="yyyy-MM-dd 00:00:00"
                 v-model="changeApplicationFilters.createTimeStart"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item required>
                <el-date-picker type="date" placeholder="提交时间止" style="width: 100%;" value-format="yyyy-MM-dd 23:59:59"
                 v-model="changeApplicationFilters.createTimeEnd"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="5">
             <el-form-item >
              <el-select v-model="changeApplicationFilters.approvalStatus" style="width: 100%;" placeholder="审批状态" >
                <el-option label="待审核" value="forAudit"></el-option>
                <el-option label="退回" value="sendBack"></el-option>
                <el-option label="已通过" value="getThrough"></el-option>
              </el-select>
             </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item >
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="getChangeApplicationSelectPager()">查询
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
      </el-form>
    </div>
    <div class="main-body-table" id="queryList">
        <el-table :data="changeApplicationTableData" style="width: 100%" >
          <el-table-column type="index" label="序号" width="60"> </el-table-column>
          <el-table-column prop="id" label="变更申请编号" width="180"></el-table-column>
          <el-table-column prop="typeTabName" label="变更事项" width="150"></el-table-column>
          <el-table-column prop="submitTime" label="提交时间" width="120"></el-table-column>
          <el-table-column prop="rejectReason" label="退回原因" width="180"></el-table-column>
          <el-table-column prop="approvalStatusTabName" label="审批状态" width="150"></el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button
              v-if="scope.row.approvalStatus == 'sendBack'"
              size="small"
              type="primary"
              @click="showChangeForm(scope.row)">
                重新编辑
              </el-button>
              <el-button
              v-if="scope.row.approvalStatus == 'forAudit'"
              size="small"
              type="primary"
              @click="showChangeForm(scope.row)">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="main-body-table-page"
          layout="total, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-size="page.size"
          :total="page.total">
        </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getChangeApplicationSelectPageThis
} from '@/views/yourbiz/api/org/ChangeOrgInfo';
import dateUtil from '@/views/common/js/util';
import {
  apiServerUrl
} from '@/bizConfig';
export default {
  data() {
    return {
      showQuery :true,
      changeFormVisible:false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      // 变更审批查询条件
      changeApplicationFilters: {
        approvalStatus: 'forAudit' // 设置filter默认值
      },
      // 变更数据列表
      changeApplicationTableData: [],
      // 查询条件
      filters: {
        createTimeStart: '',
        createTimeEnd: '',
        approvalStatus: ""
      },
    }
  },
  mounted() {
    this.getChangeApplicationSelectPager();
  },
  methods: {
    handleCurrentChange(val) {
      this.page.current = val
      //this.getChangeList()
    },
    //查询列表
    getChangeApplicationSelectPager() {
      this.changeApplicationFilters.current = this.page.current //当前页数
      this.changeApplicationFilters.size = this.page.size
      getChangeApplicationSelectPageThis(this.changeApplicationFilters).then(result => {
        if(result.code == 20000 && result.data) {
          this.changeApplicationTableData = result.data;
          this.changeApplicationTableData.forEach(row => {
            row.approvalStatusTabName = dateUtil.findDictItemValueByItemCode(row.approvalStatus, this.utils.approvalStatus);
            row.typeTabName = dateUtil.findDictItemValueByItemCode(row.type, this.utils.changeType);
          });
          // 使数组的更新被VUE检测到
          this.changeApplicationTableData.push({});
          this.changeApplicationTableData.pop();
          this.page.total = result.total;
        }
      }).catch(() => {
        return this.$message.error(`数据查询异常`);
      });
    },
    // 展示变更详细信息
    showChangeForm(row) {
      // 路由跳转-跳转到变更申请
      this.$router.push({
        path: '/orgInfo/changeRequest',
        query: {
          type:row.type
        }})
    }

  }
}
</script>

<style lang="scss"></style>
